import API from '../Utils/Api';
import {  toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';
// return the token from the session storage
export const getToken = () => {
  return localStorage.getItem("token") || null;
};

// remove the token and user from the session storage
export const removeUserSession = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("department");
  localStorage.removeItem("level");
};

// set the token and user from the session storage
export const setUserSession = (token,department,level) => {
  localStorage.setItem("token", token);
  localStorage.setItem("department", department);
  localStorage.setItem("level", level);
};
 
export const getBaseurl = () => {
	 //const BASE_URL = 'http://localhost:3000/';
	const BASE_URL = 'https://bfbackoffice.mandanstaging.com/';
	//const BASE_URL = 'https://backoffice.bluefaucet.com/';
  return BASE_URL
};
export const getUserDetails = (token) => {
	let formData = new FormData(); 
	formData.append('token', token);
	API.post('get_profile', formData)
		.then(response => {
			console.log(response);
		if(response.data.status === 0){
			
		}else{
		   
		}                  
	}).catch(error => {
		 
	});  
};	
export const gettoastwarning = (message,url_link) => {
	toast.warning(message, {
				bodyClassName: 'custom-toast-body',
				toastClassName: 'custom-toast',
				position: "top-center",
				autoClose: 3000, 
		  onClose: () => {
			  if(url_link!=='')
			  {
				window.location.href = url_link;
			  }
		  },
		  style: {
			width: '320px', // Set the desired width
			marginTop: '5px', // Set the desired top margin
		  },
		  bodyStyle: {
			marginTop: '20px', // Set the desired margin for the text content
			marginBottom: '20px', // Set the desired margin for the text content
		  },
		});
}
export const gettoastsuccess = (message,url_link) => {
	toast.success(message, {
				bodyClassName: 'custom-toast-body',
				toastClassName: 'custom-toast',
				position: "top-center",
				autoClose: 3000, 
		  onClose: () => {
			  if(url_link!=='')
			  {
					window.location.href = url_link;
			  }
		  },
		  style: {
			width: '320px', // Set the desired width
			marginTop: '5px', // Set the desired top margin
		  },
		  bodyStyle: {
			marginTop: '20px', // Set the desired margin for the text content
			marginBottom: '20px', // Set the desired margin for the text content
		  },
		});
}
export const chkMenu = (pagename) => {
	 let level = parseInt(localStorage.getItem("level"));
	let department = parseInt(localStorage.getItem("department"));
   
		if(level===1)
		{
			if(department===1)
			{
					if(pagename==='hr-creation')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===2)
			{
				if(pagename==='dashboard-sales-vp-of-sales-representative')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===3)
			{
				if(pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===4)
			{
					if(pagename==='customer-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===5)
			{
				if(pagename==='overview' || pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===6)
			{
				 if(pagename==='overview' || pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}
		}else if(level===2)
		{
			if(department===1)
			{
					if(pagename==='hr-creation')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===2)
			{
				if(pagename==='dashboard-sales-vp-of-sales-representative')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===3)
			{
				if(pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===4)
			{
					if(pagename==='customer-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===5)
			{
				if(pagename==='overview' || pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===6)
			{
				 if(pagename==='overview' || pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}
		}else if(level===3)
		{
			if(department===1)
			{
					if(pagename==='hr-creation')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===2)
			{
				if(pagename==='dashboard-sales-vp-of-sales-representative')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===3)
			{
				if(pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===4)
			{
					if(pagename==='customer-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===5)
			{
				if(pagename==='overview' || pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===6)
			{
				 if(pagename==='overview' || pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}
		}else if(level===4)
		{
			if(department===1)
			{
					if(pagename==='hr-creation')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===2)
			{
				if(pagename==='dashboard-sales-vp-of-sales-representative')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===3)
			{
				if(pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===4)
			{
					if(pagename==='customer-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===5)
			{
				if(pagename==='overview' || pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===6)
			{
				 if(pagename==='overview' || pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}
		}else if(level===5)
		{
			if(department===1)
			{
					if(pagename==='hr-creation')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===2)
			{
				if(pagename==='dashboard-sales-vp-of-sales-representative')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===3)
			{
				if(pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===4)
			{
					if(pagename==='customer-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===5)
			{
				if(pagename==='overview' || pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===6)
			{
				 if(pagename==='overview' || pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}
		}else if(level===6)
		{
			if(department===1)
			{
					if(pagename==='hr-creation')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===2)
			{
				if(pagename==='dashboard-sales-vp-of-sales-representative')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===3)
			{
				if(pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===4)
			{
					if(pagename==='customer-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===5)
			{
				if(pagename==='overview' || pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}else if(department===6)
			{
				 if(pagename==='overview' || pagename==='merchant-overview')
          {
          	return 1;
          }else{
          	return 0;
          }
			}
		}else if(level===7)
		{
			return 1;
		}
};
export const addressviewhtml = (street_name,area,city,state,zip,country_id) => {
	var html='';
	if(street_name!=='')
	{
		html+='<p>'+street_name+'</p>';
	}
	if(area!=='')
	{
		html+='<p>'+area+'</p>';
	}
	if(city!=='')
	{
		html+='<p>'+city+', '+state+', '+zip+', '+country_id+'</p>';
	}
	return <div dangerouslySetInnerHTML={{__html: html}} />
}